import { ReactComponent as Mail } from 'assets/icons/socials/Mail.svg'
import { useAnimation } from 'hooks/useAnimation';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { faqIsLoading } from 'store/slices/FAQSlice';
const FAQSideText = ({ data }) => {
    const { title, desc, button_link, button_text } = data
    const container = useRef();
    const isLoading = useSelector(faqIsLoading)

    useAnimation({
        items: ['.faq-page__stills'],
        container,
        dependencies: [isLoading],
    })
    return (
        <div ref={container} >
            <div className='faq-page__stills'>
                <div className='description2'>{title}</div>
                <div className='body2'>{desc}</div>
                <Link to={button_link} className='button-text'>
                    <Mail /> {button_text}
                </Link>
            </div>
        </div>
    );
}

export default FAQSideText;